var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "md-headline" }, [_vm._v(_vm._s(_vm.title))]),
      _c(
        "md-input-container",
        {
          class: {
            "md-input-invalid":
              _vm.formSubmitted && _vm.validations.name.$invalid
          }
        },
        [
          _c("label", [_vm._v("Name")]),
          _c("md-input", {
            attrs: { id: "input-name", maxlength: 200 },
            model: {
              value: _vm.entity.name,
              callback: function($$v) {
                _vm.$set(_vm.entity, "name", $$v)
              },
              expression: "entity.name"
            }
          }),
          _vm.formSubmitted && !_vm.validations.name.required
            ? _c("span", { staticClass: "md-error" }, [
                _vm._v("This field is required")
              ])
            : _vm._e(),
          _vm.formSubmitted &&
          _vm.validations.name.required &&
          !_vm.validations.name.isUnique &&
          !_vm.validations.name.$pending
            ? _c("span", { staticClass: "md-error" }, [
                _vm._v("Must be unique")
              ])
            : _vm._e()
        ],
        1
      ),
      _c(
        "md-input-container",
        {
          class: {
            "md-input-invalid":
              _vm.formSubmitted && _vm.validations.shortDescription.$invalid
          }
        },
        [
          _c("label", [_vm._v("Short Description")]),
          _vm.formSubmitted && !_vm.validations.shortDescription.required
            ? _c("span", { staticClass: "md-error" }, [
                _vm._v("This field is required")
              ])
            : _vm._e(),
          _c("md-textarea", {
            attrs: { id: "input-short-description", maxlength: 200 },
            model: {
              value: _vm.entity.shortDescription,
              callback: function($$v) {
                _vm.$set(_vm.entity, "shortDescription", $$v)
              },
              expression: "entity.shortDescription"
            }
          })
        ],
        1
      ),
      _c(
        "md-input-container",
        [
          _c("label", [_vm._v("Long Description")]),
          _c("md-textarea", {
            attrs: { id: "input-long-description", maxlength: 500 },
            model: {
              value: _vm.entity.longDescription,
              callback: function($$v) {
                _vm.$set(_vm.entity, "longDescription", $$v)
              },
              expression: "entity.longDescription"
            }
          })
        ],
        1
      ),
      _c("md-chips", {
        attrs: {
          id: "input-chips",
          "md-max": 15,
          "md-input-placeholder": "Tags..."
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(chip) {
              return [_c("span", [_vm._v(_vm._s(chip.value))])]
            }
          }
        ]),
        model: {
          value: _vm.entity.tags,
          callback: function($$v) {
            _vm.$set(_vm.entity, "tags", $$v)
          },
          expression: "entity.tags"
        }
      }),
      _vm.formSubmitted && !_vm.validations.tags.required
        ? _c(
            "span",
            { staticClass: "error-tags", style: { color: "#EA431F" } },
            [
              _vm._v(
                "Tags field is required. Write down one and press ENTER to create a new tag."
              )
            ]
          )
        : _vm._e(),
      _c(
        "md-layout",
        [
          _c("genre-selector", {
            attrs: {
              id: "series-dropdown",
              multiple: true,
              "show-required-error":
                _vm.formSubmitted && !_vm.validations.genres.required
            },
            model: {
              value: _vm.entity.genres,
              callback: function($$v) {
                _vm.$set(_vm.entity, "genres", $$v)
              },
              expression: "entity.genres"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-746a4074", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-746a4074","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/forms/SerieForm.vue
// module id = 892
// module chunks = 0